<template>
  <v-dialog
    transition="dialog-bottom-transition"
    max-width="600"
    v-model="dialog"
  >
    <template v-slot:default="dialog">
      <v-card v-if="device">
        <v-toolbar
          color="primary"
          dark
        >

          <v-btn
            @click="handleClose"
            style="margin-right: 20px;"
          >Cerrar</v-btn>
        </v-toolbar>
        <v-card-text style="padding-top: 10px;">
        <small>Wired:</small>
        <v-card 
          style="margin-bottom: 5px;padding:5px 10px;"
          :style="{ opacity: device.WiredDHCP ? '10%' : null}"
        >
          <p><b>DHCP:</b> {{ device.WiredDHCP ? 'true' : false }} </p>
          <p><b>IP:</b> {{ device.WiredIP}} </p>
          <p><b>SubnetMask:</b> {{ device.WiredSubnetMask }} </p>
          <p><b>Gateway:</b> {{ device.WiredGateway }} </p>
          <p><b>DNS1:</b> {{ device.WiredDNS1  }} </p>
          <p><b>DNS2:</b> {{ device.WiredDNS2  }} </p>
          <p><b>DNS3:</b> {{ device.WiredDNS3  }} </p>
        </v-card>
        <small>Wireless:</small>
        <v-card 
          style="margin-bottom: 5px;padding:5px 10px;"
          :style="{ opacity: !device.WirelessEnabled ? '10%' : null}"
        >
          <p><b>Enabled:</b> {{ device.WirelessEnabled ? 'true' : false }} </p>
          <p><b>SSID:</b> {{ device.WirelessSSID }} </p>
          <p><b>DHCP:</b> {{ device.WirelessDHCP ? 'true' : false }} </p>
          <p><b>IP:</b> {{ device.WirelessIP }} </p>
          <p><b>SubnetMask:</b> {{ device.WirelessSubnetMask }} </p>
          <p><b>Gateway:</b> {{ device.WirelessGateway }} </p>
          <p><b>DNS1:</b> {{ device.WirelessDNS1 }} </p>
          <p><b>DNS2:</b> {{ device.WirelessDNS2 }} </p>
          <p><b>DNS3:</b> {{ device.WirelessDNS3 }} </p>
        </v-card>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn
            text
            @click="handleClose"
          >Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>
<script>
import axios from 'axios'
export default {
  props: {
    device: {
      type: Object,
      default: null,
    },
    onClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    dialog: false,
    errors: [],
  }),
  watch: {
    device (v) {
      this.dialog = v ? true : false
    },
  },
  methods:{
    handleClose () {
      this.onClose()
    },
  },
}
</script>

